import { captureException } from '@sentry/vue';

import { getErrorMessage } from './errorMessage';

export function logException(
  error: unknown,
  value?: Record<string, unknown>
): void;
export function logException(
  message: string,
  value?: Record<string, unknown>
): void;
export function logException(
  errorOrMessage: unknown | string,
  value?: Record<string, unknown>
): void {
  if (import.meta.env.MODE === 'development') {
    console.error(errorOrMessage, value);
  } else {
    captureException(new Error(getErrorMessage(errorOrMessage)), {
      extra: {
        value,
      },
    });
  }
}
